.DatePicker_DatePicker_6d8a94e{background-color:white;border:1px solid lightgray;display:flex;flex-direction:column;align-items:center;padding:1em}